import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

const GENERAL = 'general'
const SITE_SETTINGS = 'siteSettings'
const SYNCHRONISATION = 'synchronisation'
const ADVANCED = 'advanced'

export enum GeneralTabFieldNames {
    IDENTIFIER = 'identifier',
    DESCRIPTION = 'description',
    TAGS = 'tags',
    BILLING_TAG = 'billingTag',
    LICENSED_FOR_RPT_USER_TYPE = 'licensedForRptUserType',
    BILLED_MONTHLY = 'billedMonthly',
    DELETE_ACD_AGENTS_ON_LICENSE_DOWNGRADE = 'deleteAcdAgentsOnLicenseDowngrade',
    PART_ID_IN_TELSYS = 'partIDInTelSys',
    IS_GLOBAL = 'isGlobal',
    ID_ON_TELSYS_OWNER = 'idOnTelSysOwner',
    ID_ON_TELSYS = 'idOnTelSys',
    TELSYS_COMPONENT_TYPE = 'telSysComponentType',
    COMMS_ENABLED = 'commsEnabled'
}

export enum SiteSettingsTabFieldNames {
    RECORDING_PLAYBACK = 'recordingPlayback',
    E164_ENABLED = 'e164Enabled',
    INTERNAL_DIGIT_LEN = 'internalDigitLen',
    COUNTRY_CODE = 'countryCode',
    TIMEZONE = 'timezone',
    START_OF_DAY = 'startOfDay'
}

export enum SynchronisationTabFieldNames {
    SYNC_TYPE = 'syncType',
    SYNC_ENVIRONMENT = 'syncEnvironment',
    SECURITY_GROUP_IDS = 'securityGroupIDs',
    SYNC_OPTIONS = 'syncOptions',
    MAINTAIN_PARITY = 'maintainParity',
    FORCE_MONITORED = 'forceMonitored',
    SYNCHRONISE_SUPERVISOR_PERMISSIONS = 'synchroniseSupervisorPermissions',
    SYNC_NOW = 'syncNow',
    PHOTO_SYNC_NOW = 'photoSyncNow'
}

export enum AdvancedTabFieldNames {
    TRUNK_CAPACITY = 'trunkCapacity',
    TRUNK_CAPACITY_BURST = 'trunkCapacityBurst',
    CTI_LOG_ENABLED = 'ctiLogEnabled',
    AUTH_USER_ID_1 = 'authUserID1',
    AUTH_PASSWORD_1 = 'authPassword1'
}

const GeneralNameSpacing = (fieldName: string): string => NameSpacing(GENERAL, fieldName)
const SiteSettingsNameSpacing = (fieldName: string): string => NameSpacing(SITE_SETTINGS, fieldName)
const SynchronisationNameSpacing = (fieldName: string): string => NameSpacing(SYNCHRONISATION, fieldName)
const AdvancedNameSpacing = (fieldName: string): string => NameSpacing(ADVANCED, fieldName)

export const PARTITION_DESCRIPTION_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.DESCRIPTION)
export const PARTITION_IDENTIFIER_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.IDENTIFIER)
export const PARTITION_TAGS_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.TAGS)
export const PARTITION_BILLING_TAG_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.BILLING_TAG)
export const PARTITION_LICENSED_FOR_FIELD_NAME: string = GeneralNameSpacing(
    GeneralTabFieldNames.LICENSED_FOR_RPT_USER_TYPE
)
export const PARTITION_BILLED_MONTHLY_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.BILLED_MONTHLY)
export const PARTITION_DELETE_ACD_AGENTS_ON_DOWNGRADE_FIELD_NAME: string = GeneralNameSpacing(
    GeneralTabFieldNames.DELETE_ACD_AGENTS_ON_LICENSE_DOWNGRADE
)
export const PARTITION_ID_IN_TELSYS_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.PART_ID_IN_TELSYS)
export const PARTITION_IS_GLOBAL_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.IS_GLOBAL)
export const PARTITION_ID_ON_TELSYS_OWNER_FIELD_NAME: string = GeneralNameSpacing(
    GeneralTabFieldNames.ID_ON_TELSYS_OWNER
)
export const PARTITION_ID_ON_TELSYS_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.ID_ON_TELSYS)
export const PARTITION_TELSYS_COMPONENT_TYPE_FIELD_NAME: string = GeneralNameSpacing(
    GeneralTabFieldNames.TELSYS_COMPONENT_TYPE
)
export const PARTITION_COMMS_ENABLED_FIELD_NAME: string = GeneralNameSpacing(GeneralTabFieldNames.COMMS_ENABLED)

export const PARTITION_RECORDING_PLAYBACK_FIELD_NAME: string = SiteSettingsNameSpacing(
    SiteSettingsTabFieldNames.RECORDING_PLAYBACK
)
export const PARTITION_E164_ENABLED_FIELD_NAME: string = SiteSettingsNameSpacing(SiteSettingsTabFieldNames.E164_ENABLED)
export const PARTITION_INTERNAL_DIGIT_LEN_FIELD_NAME: string = SiteSettingsNameSpacing(
    SiteSettingsTabFieldNames.INTERNAL_DIGIT_LEN
)
export const PARTITION_COUNTRY_CODE_FIELD_NAME: string = SiteSettingsNameSpacing(SiteSettingsTabFieldNames.COUNTRY_CODE)
export const PARTITION_TIMEZONE_FIELD_NAME: string = SiteSettingsNameSpacing(SiteSettingsTabFieldNames.TIMEZONE)
export const PARTITION_START_OF_DAY_FIELD_NAME: string = SiteSettingsNameSpacing(SiteSettingsTabFieldNames.START_OF_DAY)
export const PARTITION_SYNC_TYPE_FIELD_NAME: string = SynchronisationNameSpacing(SynchronisationTabFieldNames.SYNC_TYPE)
export const PARTITION_TRUNK_CAPACITY_FIELD_NAME: string = AdvancedNameSpacing(AdvancedTabFieldNames.TRUNK_CAPACITY)
export const PARTITION_TRUNK_CAPACITY_BURST_FIELD_NAME: string = AdvancedNameSpacing(
    AdvancedTabFieldNames.TRUNK_CAPACITY_BURST
)

export const PARTITION_SYNC_ENVIRONMENT_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.SYNC_ENVIRONMENT
)
export const PARTITION_SECURITY_GROUP_IDS_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.SECURITY_GROUP_IDS
)
export const PARTITION_SYNC_OPTIONS_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.SYNC_OPTIONS
)
export const PARTITION_MAINTAIN_PARITY_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.MAINTAIN_PARITY
)
export const PARTITION_FORCE_MONITORED_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.FORCE_MONITORED
)
export const PARTITION_SYNCHRONISE_SUPERVISOR_PERMISSIONS_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.SYNCHRONISE_SUPERVISOR_PERMISSIONS
)
export const PARTITION_SYNC_NOW_FIELD_NAME: string = SynchronisationNameSpacing(SynchronisationTabFieldNames.SYNC_NOW)
export const PARTITION_PHOTO_SYNC_NOW_FIELD_NAME: string = SynchronisationNameSpacing(
    SynchronisationTabFieldNames.PHOTO_SYNC_NOW
)

export const PARTITION_CTI_LOG_ENABLED_FIELD_NAME: string = AdvancedNameSpacing(AdvancedTabFieldNames.CTI_LOG_ENABLED)
export const PARTITION_AUTH_USER_ID_1_FIELD_NAME: string = AdvancedNameSpacing(AdvancedTabFieldNames.AUTH_USER_ID_1)
export const PARTITION_AUTH_PASSWORD_1_FIELD_NAME: string = AdvancedNameSpacing(AdvancedTabFieldNames.AUTH_PASSWORD_1)
